
<div  *ngIf="!isLoading">
  
<div class="row"></div>
<div class="page_header mt-20">
  <h1 class="heading">
    Passenger List
  </h1>
  <p class="username"><span class="blue-text">{{ user?.UserName }}</span></p>
  <strong>
    <h5>
      Date - <span class="blue-text">{{tripDate}}</span>
      Depart from - <span class="blue-text">{{ tripDetails.place_from }}</span>
      Destination - <span class="blue-text">{{ tripDetails.place_to }}</span>
    </h5>
  </strong>
</div>
<br>
<div  class="content-wrapper">
  <label
  class="center"
  fileDragDrop
  (filesChangeEmiter)="handleFileUpload($event)"
>
  <input
    class="file-upload"
    style="display: none"
    onclick="this.value=''"
    id="fileupload"
    #fileupload
    type="file"
    (change)="handleFileUpload($event)"
  />
  <img src="../../assets/img/vector-51@2x.png" height="18" /> 
  <!-- <br />Drag and drop<br /> -->
  <span  style="text-decoration: underline; color: #274c9c"><b>Import Passenger List</b></span>


</label>

  <button title="Save" type="submit" id="btnSave" class="btn hd-btn" (click)="download()">Download Upload Template</button>
  <button title="Save" type="submit" id="btnSave" class="btn hd-btn" (click)="copyFromForward()" *ngIf="isReturnTrip">Copy from forward trip</button>
</div>

<button
class="btn hd-btn"
(click)="back()"
title="Back"

>
Back to Trips
</button>


<div class="table-responsive">
  <br>
    <table class="table custom_table" cellspacing="0" width="100%">
      <thead>
        <tr>

          <th class="th-sm">
            Name
            <i
              style="vertical-align: middle"
              class="fa fa-sort"
              aria-hidden="true"
              (click)="onSortClick('first_name', $event)"
            ></i>
          </th>
          <th class="th-sm">
            Surname
            <i
              style="vertical-align: middle"
              class="fa fa-sort"
              aria-hidden="true"
              (click)="onSortClick('last_name', $event)"
            ></i>
          </th>

          <th class="th-sm">
            Nationality
            <i
              style="vertical-align: middle"
              class="fa fa-sort"
              aria-hidden="true"
              (click)="onSortClick('identity', $event)"
            ></i>
          </th>

          <th class="th-sm">
            ID Number
            <i
              style="vertical-align: middle"
              class="fa fa-sort"
              aria-hidden="true"
              (click)="onSortClick('id_number', $event)"
            ></i>
          </th>

          <th class="th-sm">
            Passport Number
            <i
              style="vertical-align: middle"
              class="fa fa-sort"
              aria-hidden="true"
              (click)="onSortClick('passport_number', $event)"
            ></i>
          </th>

          <th class="th-sm">
            Telephone of next of kin
            <i
              style="vertical-align: middle"
              class="fa fa-sort"
              aria-hidden="true"
              (click)="onSortClick('cellphone', $event)"
            ></i>
          </th>

          <th class="th-sm" >
            Actions
          </th>
          </tr>
          <tr>
            <td>
              <input type="text" name="first-name" class="form-control input-sm form-control-sm"/>
            </td>
            <td>
              <input  type="text" name="lastname" class="form-control input-sm form-control-sm"/>
            </td>
            <td> 
              <!-- <select>
              <option *ngFor="let country of ddlCountries" [ngValue]="country.id">{{country.desc}}
              </option>
          </select> -->

          <select  [(ngModel)]="selectedCountryId">
            <option *ngFor="let country of ddlCountries" [ngValue]="country.id">{{country.desc}}</option>
          </select>
        </td>
            <td> <input  type="text" name="identity" class="form-control input-sm form-control-sm"/></td>
            <td> <input  type="text" name="passport_number" class="form-control input-sm form-control-sm"/></td>
            <td><input  type="text" name="cellphone" class="form-control input-sm form-control-sm"/></td>
<td >
  <button title="Save" type="submit" id="btnSave" class="btn hd-btn" (click)="savePassenger()">Save</button>

</td>
          </tr>
          </thead>
          
    <tbody *ngIf="listPassengersFromDB.length">
        <ng-container
          *ngFor="
            let acc of listPassengersFromDB
              | paginate : { itemsPerPage: pageSize, currentPage: page };
            let i = index
          "
        >
          <tr>
            <td>{{acc.first_name}}</td>
            <td>{{ acc.last_name }}</td>
            <td>{{ acc.Nationality }}</td>
            <td>{{ acc.id_number }}</td>
            <td>{{ acc.passport_number }}</td>
            <td>{{ acc.cellphone }}</td>
            <td  class="text-center">
                <span
                  id="edit"
                  title="Edit Account"
                  style="margin: 0%; margin-bottom: 7px"
                  class="btn btn-sm pull-center myButton"
                  (click)="actionClicked(0, acc)"
                >
                  <img
                    src="/assets/newimg/border-color-13@2x.png"
                    class="permit-view"
                    (click)="assignSelected(acc)"
                    data-toggle="modal"
                    data-target="#editPassengerList"
                  />
                </span>
                <img
                  src="../../../../../assets/newimg/delete-30@2x.png"
                  title="Delete Account"
                  (click)="actionClicked(1, acc)"
                  style="cursor: pointer; width: 18px"
                />
              </td>

        </tr>
        </ng-container>
      </tbody>
          
          </table>
          </div>


          <div class="modal fade" id="editPassengerList" tabindex="-1" role="dialog" aria-labelledby="exampleModalLongTitle"
          aria-hidden="true">
         <div class="modal-dialog modal-lg" role="document">
             <div class="modal-content">
                 <div class="modal-header">
                     <h5 class="modal-title" id="exampleModalLongTitle">Update Passenger</h5>
                     <button type="button" class="close" data-dismiss="modal" aria-label="Close">
                         <span aria-hidden="true">&times;</span>
                     </button>
                 </div>
        
                 <div class="modal-body modal-lg">
        
                  <div style="width: 99%; min-height: 470px;">
                    <div class="row">
                      <div class="col-md-6">
                        <label for="first-name">First Name:</label>
                        <input type="text" id="first-name" name="first-name" class="form-control" [(ngModel)]="selectedPassenger.first_name" />
                      </div>
                      <div class="col-md-6">
                        <label for="last-name">Last Name:</label>
                        <input type="text" id="last-name" name="last-name" class="form-control" [(ngModel)]="selectedPassenger.last_name" />
                      </div>
                    </div>
                    <div class="row">
                      <div class="col-md-6">
                        <label for="nationality">Nationality:</label>
                        <select id="nationality" name="nationality" class="form-control" [(ngModel)]="selectedPassenger.passport_country_id">
                          <option *ngFor="let country of ddlCountries" [ngValue]="country.id">{{ country.desc }}</option>
                        </select>
                      </div>
                      <div class="col-md-6">
                        <label for="id-number">ID Number:</label>
                        <input type="text" id="id-number" name="id-number" class="form-control" [(ngModel)]="selectedPassenger.id_number" />
                      </div>
                    </div>
                    <div class="row">
                      <div class="col-md-6">
                        <label for="passport-number">Passport Number:</label>
                        <input type="text" id="passport-number" name="passport-number" class="form-control" [(ngModel)]="selectedPassenger.passport_number" />
                      </div>
                      <div class="col-md-6">
                        <label for="cellphone">Cellphone:</label>
                        <input type="text" id="cellphone" name="cellphone" class="form-control" [(ngModel)]="selectedPassenger.cellphone" />
                      </div>
                    </div>
                  </div>
        
        
                 </div>
                 <div class="modal-footer">
                  <button type="button" class="btn btn-md m-clr pull-right hd-btn mr-2 mt-2 myBtn" 
                    data-dismiss="modal" (click)="updatePassenger()">Save</button>
                </div>
             
            </div>
          </div>

<div
  class="col-12"
  *ngIf="isLoading"
  style="
    position: fixed;
    top: 0;
    left: 0;
    width: 100%;
    height: 100%;
    z-index: 99;
  "
>
  <app-progress></app-progress>
</div>